module.exports = __webpack_public_path__ + "ad4edfdaf606096e1a01d6f471c6f843.svg";